import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  background: '#1E0E37',
  backgroundLighter: '#31185B',
  backgroundDarker: '#140A24',
  primary: '#5D35FF',
  primaryLighter: '#6741fe',
  primaryDarker: '#5432DA',
  secondary: '#ED4EBA',
  text: '#CEC2FF',
};

export { theme };
